export enum eMortgageDocumentType {
  creditLineMortgage = 'credit_line_mortgage',
  deedOfTrust = 'deed_of_trust',
  mortgage = 'mortgage',
  securityDeed = 'security_deed',
  other = 'other',
}

export const MortgageDocumentLabels = {
  [eMortgageDocumentType.creditLineMortgage]: 'Credit Line Mortgage',
  [eMortgageDocumentType.deedOfTrust]: 'Deed of Trust',
  [eMortgageDocumentType.mortgage]: 'Mortgage',
  [eMortgageDocumentType.securityDeed]: 'Security Deed',
  [eMortgageDocumentType.other]: 'Other',
};
